import PropTypes from 'prop-types';
import { format } from 'date-fns';
// @mui
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Collapse from '@mui/material/Collapse';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// utils
import { fCurrency } from 'src/utils/format-number';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';

// ----------------------------------------------------------------------

export default function AccountPaybleTableRow({
  row,
  selected,
  onViewRow,
  onSelectRow,
  onDeleteRow,
}) {
  const {
    create_at,
    good_receipt_details,
    soLineList,
    item_id,
    invoice_no,
    document_date,
    delivery_date,
    status,
    total_paid,
    id,
    total_amount,
    inv_no,
    total_price,
    erpPayment,
    supplier,
    delivery_no,
    subTotal,
  } = row;

  const confirm = useBoolean();

  const collapse = useBoolean();

  const popover = usePopover();

  // const moment = require('moment');

  console.log('accountPaybleRow', row);

  const documentDate = new Date(create_at);

  const today = new Date();

  // Calculate the difference in days
  const timeDifference = documentDate.getTime() - today.getTime();
  const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

  // Determine if the date is in the past, today, or in the future
  let dueStatus;
  if (daysDifference < 0) {
    dueStatus = `Have Passed ${Math.abs(daysDifference)} days`;
  } else if (daysDifference === 0) {
    dueStatus = 'Due today';
  } else {
    dueStatus = `Due in ${daysDifference} days`;
  }

  const renderPrimary = (
    <TableRow
      sx={{
        backgroundColor: row?.type === true ? 'warning.lighter' : 'error.lighter',
        height: 32, // Reduced row height
        minHeight: 32,
        borderBottom: '2px solid',
        borderColor: 'grey.400',
        '& td': { py: 0.5 }, // Reduce vertical padding in cells
      }}
    >
      <TableCell>
        <Box>
          {row?.type === true ? "INV" : "PAY"}
        </Box>
      </TableCell>

      <TableCell>
        <Box
        // onClick={onViewRow}
        // sx={{
        //   cursor: 'pointer',
        //   '&:hover': {
        //     textDecoration: 'underline',
        //   },
        // }}
        >
          {row?.type === true ? row?.invoice?.invoice_no : row?.accCashBank?.voucher_number}
        </Box>
      </TableCell>

      <TableCell>
        <ListItemText
          primary={row?.type === true ? row?.invoice?.document_date.substring(0, 10) : row?.invoicePayment?.paymentDate.substring(0, 10)}
          primaryTypographyProps={{ typography: 'body2', noWrap: true }}
          secondaryTypographyProps={{
            mt: 0.5,
            component: 'span',
            typography: 'caption',
          }}
        />
      </TableCell>
      <TableCell>
        {row?.type === true ? "" : "- "}
        {row?.amount != null ? Number(row.amount).toFixed(3) : '-'}
      </TableCell>
      <TableCell>
        <ListItemText
          primary={row?.balanceAmount != null ? Number(row.balanceAmount).toFixed(3) : '-'}

          primaryTypographyProps={{ typography: 'body2', noWrap: true }}
          secondaryTypographyProps={{
            mt: 0.5,
            component: 'span',
            typography: 'caption',
          }}
        />
      </TableCell>
    </TableRow>
  );

  console.log('soLineList', soLineList);
  const renderSecondary = (
    <TableRow>
      <TableCell sx={{ p: 0, border: 'none' }} colSpan={10}>
        <Collapse
          in={collapse.value}
          timeout="auto"
          unmountOnExit
          sx={{ bgcolor: 'background.neutral' }}
        >
          <Stack component={Paper} sx={{ m: 1.5 }}>
            <Stack
              direction="row"
              alignItems="center"
              sx={{
                p: (theme) => theme.spacing(1.5, 2, 1.5, 1.5),
                color: 'red', // Set text color to red
                '&:not(:last-of-type)': {
                  borderBottom: (theme) => `solid 2px ${theme.palette.background.neutral}`,
                },
              }}
            >
              <ListItemText
                primaryTypographyProps={{
                  typography: 'body2',
                  sx: { color: 'red' }, // Set primary text color to red
                }}
                secondaryTypographyProps={{
                  component: 'span',
                  color: 'red', // Set secondary text color to red
                  mt: 0.5,
                }}
              />
            </Stack>
          </Stack>
        </Collapse>
      </TableCell>
    </TableRow>
  );

  return (
    <>
      {renderPrimary}

      {renderSecondary}

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() => {
            confirm.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>

        {/* <MenuItem
          onClick={() => {
            onViewRow();
            popover.onClose();
          }}
        >
          <Iconify icon="solar:eye-bold" />
          View
        </MenuItem> */}
      </CustomPopover>

      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you sure want to delete?"
        action={
          <Button variant="contained" color="error" onClick={onDeleteRow}>
            Delete
          </Button>
        }
      />
    </>
  );
}

AccountPaybleTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  onViewRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
};
